export const getTasmanieData = () => ({
  name: "Tasmanie",
  country: "Australie",
  description: "La Tasmanie est une île viticole de climat frais au sud de l'Australie, réputée pour ses vins effervescents de classe mondiale et ses Pinot Noir élégants. Son climat océanique et ses influences antarctiques créent des conditions idéales pour des vins de grande finesse.",
  type: "region",
  mapAreas: [
    { region: "Tasmanie", x: 65, y: 90, color: "#faf8fa", size: 4 }
  ],
  statistics: {
    totalArea: "2,000 ha",
    production: "0.1 million hectolitres",
    appellations: "Tasmania GI",
    subregions: "3 sous-régions principales",
    exportPercentage: "20%"
  },
  characteristics: {
    climate: "Climat océanique avec influence antarctique, étés frais, hivers froids, précipitations régulières",
    soil: "Sols volcaniques, argileux, sableux, excellente diversité géologique",
    viticulture: "Viticulture moderne, rendements limités, qualité privilégiée"
  },
  wineStyles: {
    red: "Pinot Noir élégants et complexes, Shiraz frais, assemblages délicats",
    white: "Chardonnay élégants et complexes, Sauvignon Blanc aromatiques, Riesling frais",
    rose: "Rosés frais et fruités, parfaits pour l'apéritif",
    sparkling: "Vins effervescents de méthode traditionnelle, spécialité régionale"
  },
  history: "La viticulture en Tasmanie a débuté dans les années 1970. L'île s'est rapidement imposée comme l'une des plus prestigieuses d'Australie pour les vins de climat frais, reconnue pour ses vins effervescents et ses Pinot Noir.",
  foodPairing: "Cuisine tasmanienne : fruits de mer, poissons, viandes blanches, fromages affinés, cuisine fusion.",
  subregions: {
    "tamar-valley": {
      name: "Tamar Valley",
      description: "Zone septentrionale, réputée pour ses Pinot Noir élégants et ses vins effervescents.",
      characteristics: {
        climate: "Océanique, influence antarctique",
        soil: "Sols volcaniques et argileux",
        viticulture: "Vignobles modernes, climat frais"
      },
      grapeVarieties: {
        white: ["Chardonnay", "Sauvignon Blanc", "Riesling"],
        red: ["Pinot Noir", "Shiraz", "Cabernet Sauvignon"]
      },
      wineStyles: {
        "pinot-noir": "Rouges élégants et complexes",
        "effervescent": "Bulles de classe mondiale"
      },
      foodPairing: "Fruits de mer, poissons, fromages affinés"
    },
    "coal-river-valley": {
      name: "Coal River Valley",
      description: "Zone méridionale, connue pour ses vins blancs frais et ses rouges élégants.",
      characteristics: {
        climate: "Océanique, influence antarctique",
        soil: "Sols argileux et sableux",
        viticulture: "Vignobles historiques, qualité privilégiée"
      },
      grapeVarieties: {
        white: ["Chardonnay", "Sauvignon Blanc", "Riesling"],
        red: ["Pinot Noir", "Shiraz", "Cabernet Sauvignon"]
      },
      wineStyles: {
        "blanc": "Blancs frais et aromatiques",
        "rouge": "Rouges élégants et équilibrés"
      },
      foodPairing: "Fruits de mer, poissons, cuisine traditionnelle"
    },
    "derwent-valley": {
      name: "Derwent Valley",
      description: "Zone centrale, réputée pour ses vins rouges structurés et ses blancs complexes.",
      characteristics: {
        climate: "Océanique, influence antarctique",
        soil: "Sols argileux et calcaires",
        viticulture: "Vignobles modernes, qualité privilégiée"
      },
      grapeVarieties: {
        white: ["Chardonnay", "Sauvignon Blanc", "Riesling"],
        red: ["Pinot Noir", "Shiraz", "Cabernet Sauvignon"]
      },
      wineStyles: {
        "rouge": "Rouges structurés et complexes",
        "blanc": "Blancs complexes et aromatiques"
      },
      foodPairing: "Viandes rouges, volailles, cuisine traditionnelle"
    }
  }
}); 